import { render } from "./SearchPopoverView.vue?vue&type=template&id=a7ea46a8&scoped=true"
import script from "./SearchPopoverView.vue?vue&type=script&lang=js"
export * from "./SearchPopoverView.vue?vue&type=script&lang=js"

import "./SearchPopoverView.vue?vue&type=style&index=0&id=a7ea46a8&scoped=true&lang=css"

import exportComponent from "/Users/fredde/programvara/boove.se/w3.boove.se/w3.boove.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a7ea46a8"]])

export default __exports__